<template>
  <div class="uebersicht">
    <div class="columns">
      <div class="column" style="text-align:left;">
        <router-link style="min-width:180px" class="button is-primary" to="/rule">Neue Regel</router-link>
      </div>
      <div class="column">

      </div>
      <div class="column">

      </div>
<!--      <div class="column">
        <b-field>
          <b-input placeholder="Suche..."
                   type="search"
                   icon="magnify"
                   v-model="search">
          </b-input>
        </b-field>
      </div>-->
    </div>
    <b-table :data="data" :loading="loading" checkable hoverable>
      <template slot-scope="props">
        <b-table-column field="id" label="ID" sortable>
          {{ props.row.id }}
        </b-table-column>
        <b-table-column field="condition" label="Bedingung" sortable>
         {{condTypeDescription(props.row.type,props.row.data)}}
        </b-table-column>
        <b-table-column field="actions" label="Aktion" sortable>
          <div v-html="actionTypeDescription(props.row.actions)"></div>
        </b-table-column>
        <b-table-column width="115" custom-key="actions">
          <button  style="border:0px;margin-right:7px;" class="button is-small" @click="editItem(props.row)">
            <b-icon type="is-primary" icon="pencil"></b-icon>
          </button>
          <!--<button  style="border:0px;margin-right:7px;" class="button is-small" @click="copyItem(props.row)">
          <b-icon type="is-primary" icon="content-copy"></b-icon>
        </button>-->
          <button style="border:0px;" class="button is-small" @click="deleteItem(props.row)">
            <b-icon type="is-danger" icon="delete"></b-icon>
          </button>
        </b-table-column>
      </template>

      <!--<template slot="detail" slot-scope="props">
        <tabledetail :row="props.row"></tabledetail>
      </template>-->

      <template slot="empty">
        <section class="section">
          <div class="content has-text-grey has-text-centered">
            <p>
              <b-icon
                  icon="emoticon-sad"
                  size="is-large">
              </b-icon>
            </p>
            <p>Keine Regeln gefunden.</p>
          </div>
        </section>
      </template>

    </b-table>
    </b-table>
  </div>
</template>

<script>
// @ is an alias to /src

const axios = require('axios');

export default {
  name: "producer",
  components: {
    //  HelloWorld
  },
  data() {
    return {
      search: "",
      loading: true,
      data: [],
      allData: [] //Für Suchfunktion nötig
    }
  },
  watch: {
  },
  mounted: function () {
    this.loadItems();
  },
  methods: {
    condTypeDescription(type, data) {
      // Folgende Bedingungstypen sind definiert 1: Filtern nach Bereich der Stückzahl und Verpackungscode
      if (type===1) {
        return `Stückzahl > ${data.quantity_bg} und <= ${data.quantity_sm_eq}, Verpackungscode enthält ${data.package_code_contains}`
      }
      if (type===2) {
        return `Vom ${data.selectedDayFrom}.${data.selectedMonthFrom} bis ${data.selectedDayTo}.${data.selectedMonthTo} für Aufschlagsatz-Id ${data.extraChargeId}`
      }
    },
    actionTypeDescription(actions) {
      let returnValue=""
      for (let action of actions) {
        // Folgende Aktionen sind definiert 1: Text ausgeben
        if (action.type === 1 && action.data!=null) {
          returnValue+=`Text ausgeben: ${action.data.text}`
        }
        if (action.type === 2 && action.data!=null) {
          returnValue+=`Preiserhöhung um ${action.data.priceRise}%.<br>
          Im Angebot als Hinweis anzeigen:
          ${action.data.offerTextInIntervall}
          `
        }
      }
      return returnValue
    },
    loadItems: function() {
      var _this = this;
      _this.loading = true;
      axios.get('/api/rules', {
        withCredentials: true,
      })
          .then(function (response) {
            console.log(response.data);
            _this.data = response.data;
            _this.allData = response.data;
            _this.loading = false;
          })
          .catch(function (error) {
            console.log(error);
            _this.loading = false;
          })
          .then(function () {
            // always executed
          });

    },
    deleteItem: function(item) {
      console.log("DELETE "+item.id);
      var vm = this;
      this.$buefy.dialog.confirm({
        title: 'Regel löschen',
        message: 'Soll die Regel mit der id  "'+ item.id +'" wirklich gelöscht werden?',
        confirmText: 'Regel  löschen',
        type: 'is-danger',
        hasIcon: true,
        cancelText: 'Abbrechen',
        onConfirm: function() {
         // console.log(vm.search);
          axios.delete('/api/rules/'+item.id, {
            withCredentials: true,
          })
              .then(function (response) {
                console.log(response.data);
                vm.$buefy.toast.open('Die Regel wurde gelöscht!');
                vm.loadItems();
              })
              .catch(function (error) {

              })
              .then(function () {
                // always executed
              });

        }

      })
    },
    /*copyItem: function(item) {
      console.log("COPY "+item.id);
    },  */
    editItem: function(item) {
      console.log("EDIT "+item.id);
      this.$router.push({ name: 'editrule', params: { id: item.id } })
    }
  }
};
</script>
